import { createContext } from 'react'
import { ToastContextType } from './Toast.types'

export const ToastContext = createContext<ToastContextType | undefined>(undefined)
